import { useEffect, useState } from "react";
import axios from "axios";

export default function AboutQuiz2() {
  const [data, setData] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get("https://web1024.docmaster.in:5007/api/school/syllabus/published-about-quiz");
      const dataa = response?.data;
      setData(dataa?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ color: "black", padding: "10px 16px" }}>
      {/* Simple & Classic How to Participate Box - Side by Side */}
      <div
        style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderLeft: "4px solid #7B2FF7",
          borderRadius: "6px",
          padding: "10px 14px",
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            fontSize: "14px",
            fontWeight: "700",
            color: "#1e293b",
            marginBottom: "8px",
          }}
        >
          How to Participate:
        </div>

        {/* Steps Side-by-Side */}
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            gap: "10px",
            flexWrap: "wrap",
            marginBottom: "8px",
          }}
        >
          {/* Step 1 */}
          <div
            style={{
              flex: "1 1 200px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              padding: "7px 10px",
            }}
          >
            <span
              style={{
                backgroundColor: "#7B2FF7",
                color: "#ffffff",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "700",
                flexShrink: 0,
              }}
            >
              1
            </span>
            <span style={{ fontSize: "12.5px", color: "#334155" }}>
              Go to <strong>List of Students</strong> tab
            </span>
          </div>

          {/* Step 2 */}
          <div
            style={{
              flex: "1 1 200px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              padding: "7px 10px",
            }}
          >
            <span
              style={{
                backgroundColor: "#7B2FF7",
                color: "#ffffff",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "700",
                flexShrink: 0,
              }}
            >
              2
            </span>
            <span style={{ fontSize: "12.5px", color: "#334155" }}>
              Click on <strong>Add Student</strong>
            </span>
          </div>

          {/* Step 3 */}
          <div
            style={{
              flex: "1 1 200px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              padding: "7px 10px",
            }}
          >
            <span
              style={{
                backgroundColor: "#7B2FF7",
                color: "#ffffff",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "700",
                flexShrink: 0,
              }}
            >
              3
            </span>
            <span style={{ fontSize: "12.5px", color: "#334155" }}>
              Enter details &amp; <strong>Submit</strong>
            </span>
          </div>
        </div>

        {/* Note */}
        <p
          style={{
            margin: 0,
            fontSize: "12px",
            color: "#475569",
            lineHeight: "1.4",
          }}
        >
          <strong style={{ color: "#0f172a" }}>Note:</strong> Students will receive their login credentials via email to log in and participate in the quizzes accordingly.
        </p>
      </div>

      {/* Dynamic Content */}
      {Array.isArray(data) &&
        [...data]
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
          .map((item, index) => (
            <div key={index} style={{ marginBottom: "12px" }}>
              <h2 style={{ textAlign: "left", fontSize: "15px", margin: "8px 0 4px" }}>
                <strong>{item.heading}</strong>
              </h2>

              <div
                className="topic-description"
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              />
            </div>
          ))}
    </div>
  );
}
